import React from 'react';
import AttachmentViewWithPreview from "./with-preview/with-preview";
import AttachmentViewNoPreview from "./no-preview/no-preview";
import AttachmentViewWithPreviewInEditor from "./in-editor/with-preview";
import AttachmentViewUploadNoPreview from "./upload/upload-no-preview";
import AttachmentViewUploadWithPreview from "./upload/upload-with-preview";
import Attachment from "../../../model2/attachment/attachment";
import {AttachFileMode} from "../const";
import AttachmentViewNoPreviewSmall from "./no-preview/no-preview-small";
import AttachmentViewUploadNoPreviewSmall from "./upload/upload-no-preview-small";

export type AttachmentViewProps = {
    attachment      : Attachment
    mode            : AttachFileMode
    onPreview?      : callback
    onRemove?       : callback
    onAddToMessage? : callback
}


// const debug = "AttachmentView"
const debug = false

export default function AttachmentView(props:AttachmentViewProps) {

    debug && console.log(debug, "render()", props)

    const {attachment} = props;

    if (attachment.isNewUpload) {

        if(props.mode === AttachFileMode.VIEW_AND_EDIT_SMALL || props.mode === AttachFileMode.VIEW_SMALL) {
            return <AttachmentViewUploadNoPreviewSmall {...props} />
        }

        if (attachment.previewAvailable) {
            return <AttachmentViewUploadWithPreview {...props} />
        } else {
            return <AttachmentViewUploadNoPreview {...props} />
        }

    }

    if(props.mode === AttachFileMode.VIEW_AND_EDIT_SMALL || props.mode === AttachFileMode.VIEW_SMALL) {
        return <AttachmentViewNoPreviewSmall {...props} />
    }

    switch (props.mode) {

        case AttachFileMode.EDIT_IN_EDITOR:

            debug && console.log("render edit-in-editor previewAvailable=", props.attachment)

            switch (props.attachment.preview) {

                case gd.const.attachment.preview.NOT_AVAILABLE:
                    return <AttachmentViewNoPreview {...props} />

                case gd.const.attachment.preview.AVAILABLE:
                    return <AttachmentViewWithPreviewInEditor {...props} />

                case gd.const.attachment.preview.UNKNOWN:

                    switch(attachment.fileType) {
                        case gd.const.attachment.fileType.IMAGE:
                        case gd.const.attachment.fileType.GRAPHIC_SOURCE:
                            return <AttachmentViewWithPreviewInEditor {...props} />

                        default:
                            return <AttachmentViewNoPreview {...props} />
                    }
            }
            break

        case AttachFileMode.VIEW_IN_EDITOR:

            switch (attachment.preview) {

                case gd.const.attachment.preview.NOT_AVAILABLE:
                    return <AttachmentViewNoPreview {...props} />

                case gd.const.attachment.preview.AVAILABLE:
                    return <AttachmentViewWithPreviewInEditor {...props} />

                case gd.const.attachment.preview.UNKNOWN:

                    switch(attachment.fileType) {
                        case gd.const.attachment.fileType.IMAGE:
                        case gd.const.attachment.fileType.GRAPHIC_SOURCE:
                            return <AttachmentViewWithPreviewInEditor {...props} />

                        default:
                            return <AttachmentViewNoPreview {...props} />
                    }
            }
            break

        case AttachFileMode.VIEW:

            debug && console.log("render view previewAvailable=", props.attachment.previewAvailable)

            if (props.attachment.previewAvailable) {
                return <AttachmentViewWithPreview {...props} />
            }

            return <AttachmentViewNoPreview {...props} />

        case AttachFileMode.VIEW_AND_EDIT:

            debug && console.log("render view previewAvailable=", props.attachment.previewAvailable)

            if (props.attachment.previewAvailable) {
                return <AttachmentViewWithPreview {...props} showRemoveButton={true} />
            }

            return <AttachmentViewNoPreview {...props} showRemoveButton={true} />

        // i.e. when edit message with attachmetns
        case AttachFileMode.EDIT:
            if (props.attachment.previewAvailable) {
                return <AttachmentViewWithPreview {...props} showRemoveButton={true} />
            }

            return <AttachmentViewNoPreview {...props} showRemoveButton={true} />

    }

    return null
}
